export const File = {
  acl: {
    NONE: 'NONE',
    BROWSE: 'BROWSE',
    VIEW: 'VIEW',
    READ: 'READ',
    WRITE: 'WRITE',
    DELETE: 'DELETE'
  },
  systemFolderType: {
    WORKFLOWS: 'WORKFLOWS',
    REGULATED_CONTENT: 'REGULATED_CONTENT',
    TEMPLATES: 'TEMPLATES',
    FORMS: 'FORMS',
    CONTAMINATED: 'CONTAMINATED',
    UPLOAD: 'UPLOAD',
    REPORTS: 'REPORTS',
    SYSTEM_DOCUMENTS: 'SYSTEM_DOCUMENTS',
    EMAIL_UPLOADS: 'EMAIL_UPLOADS',
    INIT_ETMF_FILES: 'INIT_ETMF_FILES',
    DOCUMENT_MIGRATIONS_AND_EXPORTS: 'DOCUMENT_MIGRATIONS_AND_EXPORTS',
    SETTINGS_AND_SYSTEM_EXPORTS_IMPORTS: 'SETTINGS_AND_SYSTEM_EXPORTS_IMPORTS'
  },
  folderFeatureType: {
    ETMF: 'ETMF',
    RCR: 'RCR'
  },
  type: {
    FOLDER: 'FOLDER',
    DOCUMENT: 'DOCUMENT',
    REFERENCE: 'REFERENCE',
    PLACEHOLDER: 'PLACEHOLDER'
  },
  lifecycleState: {
    APPROVED: 'APPROVED',
    DRAFT: 'DRAFT',
    EFFECTIVE: 'EFFECTIVE',
    HELPER_EXPIRING: 'HELPER_EXPIRING',
    COMPLETED: 'COMPLETED',
    EXPIRED: 'EXPIRED',
    OBSOLETE: 'OBSOLETE',
    REJECTED: 'REJECTED',
    RETIRED: 'RETIRED'
  },
  blindingStatus: {
    BLINDED: 'BLINDED',
    UNBLINDED: 'UNBLINDED'
  },
  referenceType: {
    DOCUMENT: 'DOCUMENT',
    FORM: 'FORM',
    AMENDMENT: 'AMENDMENT'
  },
  uuid: {
    REGULATED_CONTENT: 'RvldtQP-24a3e8bf-e3de-4d3a-a524-3fe0ace760ab',
    INIT_ETMF_FILES: '1eea09ee-9be6-4bdf-bb51-633f5b091104',
    FOLDER_STRUCTURE: 'WNIU4vI-ac877926-c7f7-4633-b615-8b218524d5c1',
    TEMPLATES: '2c75YHZ-ba234c5d-da99-40bd-af64-3a446e3dd08b'
  },
  upload: {
    compressionLevel: 9 // 0-9
  },
  prohibitedExtensions: {
    EXE: 'EXE',
    SH: 'SH'
  }
}
